import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { handlePluralTranslation } from 'src/app/core/utils';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'ling-credits',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule],
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss'],
})
export class CreditsComponent {
  @Input() credits: number | null | undefined;
  @Input() showName = true;
  protected readonly handlePluralTranslation = handlePluralTranslation;
}
